import React from 'react'
import TablePage from "../../common/TablePage";
import { bindActionCreators } from "redux";
import * as Actions from "../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import strings from "../../localization";
import { withSnackbar } from "notistack";
import { getStoneCuttingWorks, getDeletedStoneCuttingWorks, deleteStoneCuttingWorks, restoreStoneCuttingWorks } from '../../services/stoneCuttingWorks/StoneCuttingWorksService';
import AddStoneCuttingWork from './AddStoneCuttingWork';
import EditStoneCuttingWorks from './EditStoneCuttingWorks';
import ViewStoneCuttingWorks from './ViewStoneCuttingWorks';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { Drawer, TextField, FormControlLabel, Switch, MenuItem, ListItemIcon, ListItemText } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import PrintIcon from '@material-ui/icons/Print';
import PageState from '../../constants/PageState';
import DrawerWrapper from '../../common/DrawerWrapper';
import SelectControl from '../../components/controls/SelectControl';
import DatePickerControl from '../../components/controls/DatePickerControl';
import { getStoneCuttingWorksSelect, downloadReport } from '../../util/ReviewsUtil';
import { generateStoneCuttingWorksReview, generateStoneCuttingWorksPermit } from '../../services/report/ReportService';
import { getAllGraveyards } from '../../services/graveyard/GraveyardService';
import { getStonecutters } from '../../services/stonecutter/StonecutterService';


class StoneCuttingWorksList extends TablePage {

  tableDescription = [
    { key: 'code', label: strings.stoneCuttingWorksList.code, sort: 'code' },
    { key: 'stonecutterName', label: strings.stoneCuttingWorksList.stonecutterName, sort: 'stonecutterName' },
    { key: 'jobType', label: strings.stoneCuttingWorksList.jobType, sort: 'jobType' },
    { key: 'mainBookOfBuriedDeceasedNameSurname', label: strings.stoneCuttingWorksList.mainBookOfBuriedDeceasedNameSurname, sort: 'mainBookOfBuriedDeceasedNameSurname' },
    { key: 'permissionNumber', label: strings.stoneCuttingWorksList.permissionNumber, sort: 'permissionNumber' },
    { key: 'permissionStartDate', label: strings.stoneCuttingWorksList.permissionStartDate, transform: 'renderColumnDate', sort: 'permissionStartDate' },
    { key: 'graveyardCode', label: strings.stoneCuttingWorksList.graveyardCode, sort: 'graveyardCode' },
    { key: 'graveSiteCode', label: strings.stoneCuttingWorksList.graveSiteCode, sort: 'graveSiteCode' },
    { key: 'tombstoneType', label: strings.stoneCuttingWorksList.tombstoneType, sort: 'tombstoneType' },
    { key: 'citizenName', label: strings.stoneCuttingWorksList.citizenName, sort: 'citizenName' },
    { key: 'citizenSurname', label: strings.stoneCuttingWorksList.citizenSurname, sort: 'citizenSurname' },
    { key: 'hasNote', label: strings.stoneCuttingWorksList.hasNote, transform: 'renderColumnDeleted', sort: 'hasNote' },
  ];


  constructor(props) {
    super(props);

    this.state.sortBy = "code,ASC";
    this.state.showDeleted = false;

    this.state = {
      ...this.state,
      selectStoneCuttingWorks: getStoneCuttingWorksSelect(),
      filter: { graveyards: [], stonecutters: [] },
    };

    this.generateMonthlyReport = this.generateMonthlyReport.bind(this);
  }

  fetchData() {
    let data = {
      searchParam: this.state.searchData.search,
      page: this.state.searchData.page - 1,
      size: this.state.searchData.perPage,
      companyId: this.state.companyId,
      sort: this.state.sortBy,
      userId: this.props.auth.user.id,
      searchType: this.state.data.selectedStoneCuttingWorksReview ? this.state.data.selectedStoneCuttingWorksReview.id : 0,
      stonecutter: this.state.data.stonecutter ? this.state.data.stonecutter.id : -1,
      graveyard: this.state.data.graveyard ? this.state.data.graveyard.id : -1,
    };

    const periodFrom = this.state.data.periodFrom ? new Date(this.state.data.periodFrom).toISOString() : null;
    const periodTo = this.state.data.periodTo ? new Date(this.state.data.periodTo).toISOString() : null;
    if (periodFrom) data.periodFrom = periodFrom;
    if (periodTo) data.periodTo = periodTo;

    const offset = (this.state.searchData.page - 1) * this.state.searchData.perPage;
    const withExtras = (entities) => (entities || []).map((e, i) => ({
      ...e,
      redniBroj: offset + i + 1,
      tenantNameSurname: ((e.citizenSurname || "") + " " + (e.citizenName || "")).trim(),
    }));

    {
      (this.state.companyId != undefined && !this.state.showDeleted) &&
        getStoneCuttingWorks(data).then(response => {
          if (!response.ok) {
            return;
          }
          this.setState({
            tableData: withExtras(response.data.entities),
            total: response.data.total,
          });
        });
    }

    {
      (this.state.companyId != undefined && this.state.showDeleted) &&
      getDeletedStoneCuttingWorks(data).then(response => {
          if (!response.ok) {
            return;
          }
          this.setState({
            tableData: withExtras(response.data.entities),
            total: response.data.total,
          });
        });
    }
  }

  handleDeletedChange(){
    this.setState({
      showDeleted : !this.state.showDeleted
    },() =>{ this.fetchData(); })
    
  }

  usePermissions(){
    let data = {
      userId: this.props.auth.user.id,
      category: "Каменорезачки радови"
    }
    this.getPermissionsS(data);
    this.removedItemsShow(this.props.removedItemsShow);
    
    

  }
  
  
  componentDidMount() {

    this.usePermissions()

    if (this.state.selectStoneCuttingWorks && (this.state.selectStoneCuttingWorks.length === 0 || this.state.selectStoneCuttingWorks[0].id !== -1)) {
      this.state.selectStoneCuttingWorks.unshift({ id: -1, name: strings.reviewStoneCuttingWorks.all });
    }

    getAllGraveyards().then(response => {
      if (!response.ok) {
        return;
      }
      let graveyards = response.data.entities || [];
      graveyards.unshift({ id: -1, name: strings.reviewStoneCuttingWorks.all });
      this.setState({ filter: { ...this.state.filter, graveyards } });
    });

    getStonecutters({ searchParam: "", page: 0, size: 1000, companyId: this.props.auth.user.company.id, sort: "name,ASC", userId: 0 }).then(response => {
      if (!response.ok) {
        return;
      }
      this.setState({ filter: { ...this.state.filter, stonecutters: response.data.entities || [] } });
    });

    this.setState({
      companyId: this.props.auth.user.company.id
    }, () => { this.fetchData(); })
  }

  componentWillReceiveProps(nextProps) {
    strings.setLanguage(nextProps.auth.user.language);
    this.tableDescription = [
      { key: 'code', label: strings.stoneCuttingWorksList.code, sort: 'code' },
      { key: 'stonecutterName', label: strings.stoneCuttingWorksList.stonecutterName, sort: 'stonecutterName' },
      { key: 'jobType', label: strings.stoneCuttingWorksList.jobType, sort: 'jobType' },
      { key: 'mainBookOfBuriedDeceasedNameSurname', label: strings.stoneCuttingWorksList.mainBookOfBuriedDeceasedNameSurname, sort: 'mainBookOfBuriedDeceasedNameSurname' },
      { key: 'permissionNumber', label: strings.stoneCuttingWorksList.permissionNumber, sort: 'permissionNumber' },
      { key: 'permissionStartDate', label: strings.stoneCuttingWorksList.permissionStartDate, transform: 'renderColumnDate', sort: 'permissionStartDate' },
      { key: 'graveyardCode', label: strings.stoneCuttingWorksList.graveyardCode, sort: 'graveyardCode' },
      { key: 'graveSiteCode', label: strings.stoneCuttingWorksList.graveSiteCode, sort: 'graveSiteCode' },
      { key: 'tombstoneType', label: strings.stoneCuttingWorksList.tombstoneType, sort: 'tombstoneType' },
      { key: 'citizenName', label: strings.stoneCuttingWorksList.citizenName, sort: 'citizenName' },
      { key: 'citizenSurname', label: strings.stoneCuttingWorksList.citizenSurname, sort: 'citizenSurname' },
      { key: 'hasNote', label: strings.stoneCuttingWorksList.hasNote, transform: 'renderColumnDeleted', sort: 'hasNote' },
    ];
    this.updateReviewColumns();
  }

  defaultColumns() {
    return [
      { key: 'code', label: strings.stoneCuttingWorksList.code, sort: 'code' },
      { key: 'stonecutterName', label: strings.stoneCuttingWorksList.stonecutterName, sort: 'stonecutterName' },
      { key: 'jobType', label: strings.stoneCuttingWorksList.jobType, sort: 'jobType' },
      { key: 'mainBookOfBuriedDeceasedNameSurname', label: strings.stoneCuttingWorksList.mainBookOfBuriedDeceasedNameSurname, sort: 'mainBookOfBuriedDeceasedNameSurname' },
      { key: 'permissionNumber', label: strings.stoneCuttingWorksList.permissionNumber, sort: 'permissionNumber' },
      { key: 'permissionStartDate', label: strings.stoneCuttingWorksList.permissionStartDate, transform: 'renderColumnDate', sort: 'permissionStartDate' },
      { key: 'graveyardCode', label: strings.stoneCuttingWorksList.graveyardCode, sort: 'graveyardCode' },
      { key: 'graveSiteCode', label: strings.stoneCuttingWorksList.graveSiteCode, sort: 'graveSiteCode' },
      { key: 'tombstoneType', label: strings.stoneCuttingWorksList.tombstoneType, sort: 'tombstoneType' },
      { key: 'citizenName', label: strings.stoneCuttingWorksList.citizenName, sort: 'citizenName' },
      { key: 'citizenSurname', label: strings.stoneCuttingWorksList.citizenSurname, sort: 'citizenSurname' },
      { key: 'hasNote', label: strings.stoneCuttingWorksList.hasNote, transform: 'renderColumnDeleted', sort: 'hasNote' },
    ];
  }

  updateReviewColumns() {
    const review = this.state.data.selectedStoneCuttingWorksReview;
    const id = review ? review.id : -1;
    if (id >= 1 && id <= 6) {
      this.tableDescription = [
        { key: 'redniBroj', label: strings.stoneCuttingWorksList.ordinalNumber, sort: 'redniBroj' },
        { key: 'permissionNumber', label: strings.stoneCuttingWorksList.permissionNumber, sort: 'permissionNumber' },
        { key: 'stonecutterName', label: strings.stoneCuttingWorksList.stonecutterName, sort: 'stonecutterName' },
        { key: 'jobType', label: strings.stoneCuttingWorksList.jobType, sort: 'jobType' },
        { key: 'graveyardCode', label: strings.stoneCuttingWorksList.graveyardCode, sort: 'graveyardCode' },
        { key: 'graveSiteCode', label: strings.stoneCuttingWorksList.graveSiteCode, sort: 'graveSiteCode' },
        { key: 'tombstoneType', label: strings.stoneCuttingWorksList.tombstoneType, sort: 'tombstoneType' },
        { key: 'tenantNameSurname', label: strings.stoneCuttingWorksList.tenantNameSurname, sort: 'tenantNameSurname' },
        { key: 'permissionStartDate', label: strings.stoneCuttingWorksList.permissionStartDate, transform: 'renderColumnDate', sort: 'permissionStartDate' },
      ];
    } else {
      this.tableDescription = this.defaultColumns();
    }
  }

  changeReviewData = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      data: { ...this.state.data, [name]: value },
      sortBy: name === 'selectedStoneCuttingWorksReview' ? "code,ASC" : this.state.sortBy,
    }, () => {
      if (name === 'selectedStoneCuttingWorksReview') {
        this.updateReviewColumns();
        this.setState({
          data: { ...this.state.data, stonecutter: { id: -1 }, graveyard: { id: -1 }, periodFrom: null, periodTo: null }
        }, () => this.fetchData());
      } else {
        this.fetchData();
      }
    });
  };

  generateMonthlyReport(data, value) {
    generateStoneCuttingWorksReview(data).then(response => {
      if (!response.ok) {
        return;
      }
      this.props.enqueueSnackbar(strings.stoneCuttingWorksList.PDF, { variant: 'success' });
      downloadReport(response, value);
    });
  }

  renderFilters() {
    const id = this.state.data.selectedStoneCuttingWorksReview ? this.state.data.selectedStoneCuttingWorksReview.id : -1;
    return (
      <div className="renderFilters">
        <SelectControl
          options={this.state.selectStoneCuttingWorks}
          selected={this.state.data.selectedStoneCuttingWorksReview}
          onChange={this.changeReviewData}
          label={strings.reviewEvidentation}
          name={"selectedStoneCuttingWorksReview"}
          nameKey={"name"}
          valueKey={"id"}
        />
        {id === 1 &&
          <React.Fragment>
            <SelectControl
              options={this.state.filter.stonecutters}
              selected={this.state.data.stonecutter}
              onChange={this.changeReviewData}
              label={strings.stoneCuttingWorksList.stonecutterName}
              name={"stonecutter"}
              nameKey={"name"}
              valueKey={"id"}
            />
            <SelectControl
              options={this.state.filter.graveyards}
              selected={this.state.data.graveyard}
              onChange={this.changeReviewData}
              label={strings.stoneCuttingWorksList.graveyardCode}
              name={"graveyard"}
              nameKey={"name"}
              valueKey={"id"}
            />
            <div style={{ width: 150, marginLeft: 10 }}>
              <DatePickerControl
                label={strings.renewalProcessing.periodFrom}
                placeholder={strings.renewalProcessing.periodFrom}
                name={"periodFrom"}
                onChange={this.changeReviewData}
                date={this.state.data.periodFrom}
                isClearable={true}
                dateFormat="dd/MM/yyyy"
              />
            </div>
            <div style={{ width: 150, marginLeft: 10 }}>
              <DatePickerControl
                label={strings.renewalProcessing.periodTo}
                placeholder={strings.renewalProcessing.periodTo}
                name={"periodTo"}
                onChange={this.changeReviewData}
                date={this.state.data.periodTo}
                isClearable={true}
                dateFormat="dd/MM/yyyy"
              />
            </div>
          </React.Fragment>
        }
      </div>
    );
  }

  renderButtons() {
    let data = {
      companyId: this.state.companyId,
      selectedStoneCuttingWorksReview: this.state.data.selectedStoneCuttingWorksReview ? this.state.data.selectedStoneCuttingWorksReview.id : "",
      searchParam: this.state.searchData ? this.state.searchData.search : "",
      sort: this.state.sortBy,
      stonecutter: this.state.data.stonecutter ? this.state.data.stonecutter.id : "",
      graveyard: this.state.data.graveyard ? this.state.data.graveyard.id : "",
    };

    const periodFrom = this.state.data.periodFrom ? new Date(this.state.data.periodFrom).toISOString() : null;
    const periodTo = this.state.data.periodTo ? new Date(this.state.data.periodTo).toISOString() : null;
    if (periodFrom) data.periodFrom = periodFrom;
    if (periodTo) data.periodTo = periodTo;

    return (
      <div className="report-button">
        <IconButton
          onClick={() => this.generateMonthlyReport(data, this.state.data.selectedStoneCuttingWorksReview.value)}
          disabled={this.state.data.selectedStoneCuttingWorksReview != undefined ? (this.state.data.selectedStoneCuttingWorksReview.id == -1) : true}
        >
          {strings.stoneCuttingWorks.buttons.generateReport}
        </IconButton>
      </div>
    );
  }

  renderExtraRowMenuItems(item) {
    if (this.state.showDeleted) {
      return null;
    }
    return (
      <MenuItem onClick={() => this.printPermit(item)}>
        <ListItemIcon>
          <PrintIcon />
        </ListItemIcon>
        <ListItemText primary={strings.stoneCuttingWorksList.printPermit} />
      </MenuItem>
    );
  }

  printPermit(item) {
    this.handleMenuClose();
    if (!item || !item.id) {
      return;
    }
    generateStoneCuttingWorksPermit(item.id).then(response => {
      if (!response.ok) {
        return;
      }
      downloadReport(response, "kamenorezacka-dozvola-" + (item.code || item.id));
    });
  }

  getPageHeader() {
    return <h1>{strings.stoneCuttingWorksList.pageTitle}</h1>;
  }

  renderAddContent() {
    return <AddStoneCuttingWork cid={this.state.companyId} uemail={this.props.auth.user.email} onCancel={this.onCancel} onFinish={this.onFinish} flag={"add"} auth={this.props.auth} />
  }

  renderEditContent() {
    return <EditStoneCuttingWorks
      id={this.state.selectedItem.id}
      uemail={this.props.auth.user.email}
      cid={this.state.companyId}
      onCancel={this.onCancel}
      onFinish={this.onFinish}
      isDisabled={false}
      flag={"edit"}
      auth={this.props.auth}
    />
  }

  renderViewContent() {

    return <ViewStoneCuttingWorks id={this.state.selectedItem.id} isDisabled={true} onCancel={this.onCancel} onFinish={this.onFinish} flag={"view"} auth={this.props.auth} />
  }

  delete(item) {

    this.setState({
      lockTable: true
    });


    deleteStoneCuttingWorks(item.id, this.props.auth.user.id).then(response => {

      if (response && !response.ok) {
        this.onFinish(null);
        return;
      }

      this.props.enqueueSnackbar(strings.companyList.stoneCuttingWorkDeleted, { variant: 'success' });

      this.onFinish(item);
      this.cancelDelete();

      this.setState({
        lockTable: false
      });
    });
  }

  transformRequest(data) {
    return {
        ...data,
        userEmail: this.props.auth.user.email,
        companyId: this.state.companyId
    }
}
  restore(item){
    
    restoreStoneCuttingWorks(this.transformRequest(item)).then(response => {
      if (response && !response.ok) {
        this.onFinish(null);
        return;
      }
      this.setState({
        showDeleted : !this.state.showDeleted,
      },() =>{ this.fetchData(); })
    })
  }

  render() {
    return (
      <Grid id='table-page'>
        {this.renderDialog(strings.table.confirmDelete, strings.delete.confirmation,
          this.cancelDelete, this.delete)}
        <div className='header'>
          {this.getPageHeader()}
          <div className='show-deleted'>
            {this.state.removedItemsShow &&
              <FormControlLabel
                control={<Switch
                  checked={this.state.showDeleted}
                  onChange={this.handleDeletedChange}
                  inputProps={{ 'aria-label': 'controlled' }}
                />}
                labelPlacement="start"
                label={!this.state.showDeleted ? "Prikazi obrisane" : "Prikazi neobrisane"}
              />
            }
          </div>

          <div className='filter-controls'>

            {this.renderFilters()}

            {
              this.state.showSearch &&
              <TextField
                label={strings.table.search}
                type="search"
                name='search'
                value={this.state.searchData.search}
                onChange={this.searchChanged}
              />
            }

            {
              this.state.showAdd &&
              this.renderTableControls()
            }

            {
              this.state.data.selectedStoneCuttingWorksReview &&
              this.state.data.selectedStoneCuttingWorksReview.id != -1 &&
              this.renderButtons()
            }
          </div>
        </div>
        <Paper md={12}>
          {this.renderTable(this.state.tableData)}
        </Paper>

        <Drawer id='drawer' anchor='right' open={this.showDrawer()} onClose={() => this.setPageState(PageState.View)} ModalProps={{ disableBackdropClick: true, }} >
          <DrawerWrapper onBack={() => this.setPageState(PageState.View)}>
            {this.renderDrawerContent()}
          </DrawerWrapper>
        </Drawer>

        {this.renderGraveSiteDrawer()}
      </Grid>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(StoneCuttingWorksList)));